var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',{staticClass:"contacts-groups-view"},[(!_vm.showDetail)?_c('HubContactsGroups',{attrs:{"name":"contact-group"}}):_c('div',[_c('transition',{attrs:{"name":"custom-classes-transition","enter-active-class":"animated fadeInUp delay-animation-700","leave-active-class":"animated fadeOutDown"}},[_c('router-view')],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }